import React from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";

export default function LandingFooter() {
  return (
    <footer className="border-t border-white/5 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Brand */}
          <Link to="/landing-page" className="flex items-center gap-2.5 group">
            <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
              <Icon name="Zap" size={16} color="#fff" strokeWidth={2.5} />
            </div>
            <span className="text-lg font-bold font-heading">
              Fit<span className="text-teal-400">Pulse</span>
            </span>
          </Link>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { label: "Features", href: "#features" },
              { label: "Pricing", href: "#pricing" },
              { label: "Login", href: "/login-page", isRoute: true },
              { label: "Sign Up", href: "/registration-page", isRoute: true },
              { label: "Dashboard", href: "/executive-overview", isRoute: true },
            ]?.map((link) =>
              link?.isRoute ? (
                <Link key={link?.label} to={link?.href} className="text-sm text-slate-500 hover:text-slate-300 transition-colors font-body">
                  {link?.label}
                </Link>
              ) : (
                <a key={link?.label} href={link?.href} className="text-sm text-slate-500 hover:text-slate-300 transition-colors font-body">
                  {link?.label}
                </a>
              )
            )}
          </div>

          {/* Copyright */}
          <p className="text-xs text-slate-600 font-caption">
            © 2026 myfitnesstracking. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
